<wms-dialog-header title="{{locale.LABEL_ADVANCED_SETTINGS}}: {{liveWidgetSettingsService.activeWidgetScope.name}}" helpTitle="{{locale['LABEL_WIDGET_' + liveWidgetSettingsService.designerType]}}" (onClose)="handleClose.emit()"></wms-dialog-header>
<wms-dialog-body>
  <div id="preview-chart" class="col-xs-4">
    <div class="panel panel-default chart-designer-panel">
      <div class="panel-heading">{{locale.MESSAGE_CHART_PREVIEW}}</div>
      <div class="panel-body" #chartElement><svg></svg></div>
    </div>
  </div>

  <tabset class="designer-tabs col-xs-8 full-height">
    <ng-container *ngFor="let group of liveWidgetSettingsService.advancedPropertyGroups; let index = index">
      <tab *ngIf="group.show">
        <ng-template tabHeading class="tab-heading">
          <div class="header" title="{{locale['LABEL_WIDGET_' + liveWidgetSettingsService.designerType]}}">
            <span class="wm-text">{{locale['LABEL_PROPERTYGROUP_' + group.name.toUpperCase()]}}</span>
          </div>
        </ng-template>
        <div class="node-properties">
          <div class="properties-list">
            <ng-container *ngFor="let subGroup of group.subGroups; let index = index">
              <div class="property-subgroup category-section {{liveWidgetSettingsService.basicPropertyGroups.name}}" *ngIf="liveWidgetSettingsService.showSubGroup(subGroup)">
                <h4 class='property-subgroup-name' *ngIf="locale['LABEL_PROPERTYGROUP_'+subGroup.name.toUpperCase()]">
                  {{locale[subGroup.displayKey] || locale['LABEL_PROPERTYGROUP_'+subGroup.name.toUpperCase()]}}</h4>
                <ul>
                  <ng-container *ngFor="let property of subGroup.properties; let index = index">
                    <li class="property-{{property}} form-group app-composite-widget clearfix"
                        *ngIf="liveWidgetSettingsService?.activeWidgetScope.widgetProps[property].showindesigner"
                        [ngClass]="{'align-right': liveWidgetSettingsService?.activeWidgetScope.widgetProps[property].alignright}">
                      <label class="control-label property-label col-md-3">{{locale[liveWidgetSettingsService?.activeWidgetScope.widgetProps[property].displayKey]
                      || liveWidgetSettingsService?.activeWidgetScope.widgetProps[property].label || locale['LABEL_PROPERTY_'+property.toUpperCase()] || property}}</label>

                      <div class="property-value bind-input-wrapper" *ngIf="convertToString(liveWidgetSettingsService.shadowProperties[property]).indexOf('bind:') === 0">
                        <input wmsExpressionError [expression]="liveWidgetSettingsService.shadowProperties[property]" type="text" class="form-control app-textbox bound-value bound-value-disable" [(ngModel)]="liveWidgetSettingsService.shadowProperties[property]"
                               title="{{liveWidgetSettingsService.shadowProperties[property]}}" (change)="liveWidgetSettingsService.shadowPropertyChange(property)" [readOnly]="true"/>
                        <button class="wm-icon clear wms wms-clear" (click)="liveWidgetSettingsService.clearProperty(property, true)"></button>
                      </div>

                      <div class="property-value bind-input-wrapper"
                           *ngIf="convertToString(liveWidgetSettingsService.shadowProperties[property]).indexOf('bind:') !== 0" [ngClass]="{'select-icon-class': liveWidgetSettingsService.activeWidgetScope.widgetProps[property].widget === 'selecticon'}">
                        <wms-properties-template [isPropPanel]="false" [widgetTypeForAds]="'chart-Ads'"
                          (change)="shadowPropertyChange(property, liveWidgetSettingsService.shadowProperties[property])"
                          [advancedSettingsMode]="true"
                          [liveWidgetSettingsService]="liveWidgetSettingsService"
                          [context]="liveWidgetSettingsService"
                          [activeWidget]="liveWidgetSettingsService.activeWidgetScope"
                          [property]="property"
                          [shadowProperties]="liveWidgetSettingsService.shadowProperties"
                          [widgetType]="liveWidgetSettingsService.activeWidgetScope?.widgetType"
                          [widgetId]="liveWidgetSettingsService.activeWidgetScope?.widgetId || liveWidgetSettingsService.activeWidgetScope?.name"></wms-properties-template>
                      </div>

                      <button name="wm-bind-property-{{property}}"
                              *ngIf="liveWidgetSettingsService.activeWidgetScope.widgetProps[property].bindable === 'in-bound' || liveWidgetSettingsService.activeWidgetScope.widgetProps[property].bindable === 'in-out-bound'"
                              (click)="liveWidgetSettingsService.openWidgetBindVariableDialog(liveWidgetSettingsService.activeWidgetScope.widgetProps[property], property)"
                              [disabled]="liveWidgetSettingsService.activeWidgetScope.widgetProps[property].disabled"
                              class="wms wms-link" title="{{locale['LABEL_BIND_VARIABLE']}}"></button>
                      <i [tooltipAppendToBody]="true" placement="right" tooltip="{{locale['MESSAGE_HELP_PROPERTY_' + toUpperCase(liveWidgetSettingsService.activeWidgetScope.widgettype) + '_' + toUpperCase(property)] || locale['MESSAGE_HELP_PROPERTY_' + toUpperCase(property)]}}" class="wms wms-help"></i>
                    </li>
                  </ng-container>
                </ul>
              </div>
            </ng-container>
          </div>
        </div>
      </tab>
    </ng-container>
  </tabset>
</wms-dialog-body>
<wms-dialog-footer>
  <button class="btn app-button button-secondary"
          title="{{locale.LABEL_CANCEL}}" (click)="handleClose.emit()">{{locale.LABEL_CANCEL}}</button>
  <button (click)="liveWidgetSettingsService.saveDesignerSettings()" class="btn app-button button-primary"
          [disabled]="liveWidgetSettingsService.saveDisabled" title="{{locale.LABEL_SAVE}}">{{locale.LABEL_SAVE}}</button>
</wms-dialog-footer>

